import { FolderOpen } from 'lucide-react';
import { type FC } from 'react';

/**
 * The 48px brand-light tile with a folder in it, which both project headings
 * put before their title: the project overview's (11759:160478) and the create
 * project form's (11914:189972, exported on its own as 11971:210803).
 *
 * Decorative. Every frame that draws it sets a title beside it that carries
 * the name, so there is nothing here for a screen reader.
 *
 * The frame's `Icon / folder-open`, which Figma documents as "directory".
 * Lucide's folder-open is the same glyph — the frame exports it flattened to a
 * fill, and its outer edge lands at 0.833 of 16, which is Lucide's
 * `2 - strokeWidth/2` in a 24 viewBox and so pins the stroke at 1.5 rather
 * than the 1.75 the redesign draws its other marks at.
 *
 * Shared rather than written twice, per the promote-on-second-consumer norm
 * agents-loading.tsx records. The two tiles are identical down to the pixel,
 * and what must not drift between them is the pair of values above.
 */
export const ProjectFolderTile: FC = () => (
  <div className="flex size-12 shrink-0 items-center justify-center rounded-[var(--ds-radius-8)] bg-[var(--ds-color-bg-brand-light)]">
    <FolderOpen
      aria-hidden="true"
      className="size-4 text-[var(--ds-color-text-brand-dark)]"
      strokeWidth={1.5}
    />
  </div>
);
